import * as angular from 'angular';
import { IRequestService } from '../request.service';

export interface IdocumentationService {
    getDocumentation(): angular.IPromise<string>;
}

export class DocumentationService implements IdocumentationService {

    static serviceId = 'documentationService';
    static $inject = ['requestService'];
    constructor(private _requestService: IRequestService) {
    }

    getDocumentation() {
        this._requestService.cleanCacheAtV1('application/documentation');
        return this._requestService.getAtV1<string>('application/documentation');
    }
}